<template>
	<div id="app">

		<div class="header_mobile" v-if="isMobile">
			<div class="fl" @click="$router.push('/')">
				<div class="item">
					<img src="./assets/pic/lianminglogo.png" class="header-logo-img" />
				</div>
			</div>
			<div class="fr">
				<div class="text">
					<div class="item" @click="$router.push('/sell')">发布账号</div>
					<div class="item" @click="openLogin(0)" v-if="!login">登录</div>
					<div class="item" @click="$router.push('/user')" v-if="login">用户</div>
				</div>
				<div class="close_ic" @click="wap_show = !wap_show">
					<van-icon name="wap-nav" v-if="!wap_show" />
					<van-icon name="cross" v-if="wap_show" />
				</div>
			</div>
			<div class="app_menu" v-if="wap_show" @click="wap_show = !wap_show">
				<div class="item" v-for="(item, index) in navlist">
					<router-link :to="{ path: item.path }">
						<p>{{ item.name }}</p>
					</router-link>
				</div>
				<div class="item" @click="openKefu">
					联系客服
				</div>
			</div>
		</div>
		<div class="top-header">
			<div class="inter">
				<el-row>
					<div class="header">

						<div class="header-left"><a @click="$router.push('/')" title="您好，欢迎访问24小时租号网站平台!"
								class="secondary">您好，欢迎访问24小时租号网站平台!</a>
						</div>
						<div class="header-right">

							<div class="header-item" v-if="!login"><a @click="openLogin(0)" class="" rel="nofollow"
									title="登录">登录</a>
							</div>
							<div class="header-item" v-if="login"><a @click="$router.push('/user')" class=""
									rel="nofollow" title="个人中心">{{ userinfo.nickname }}</a>
							</div>
							<div class="header-item" v-if="login"><a @click="logout" class="" rel="nofollow"
									title="退出">退出</a>
							</div>
							<div class="header-item" v-if="!login"><a @click="openLogin(1)" class="" rel="nofollow"
									title="免费注册">注册</a>
							</div>


							<div class="header-item"><a @click="$router.push('/business')" class="" rel="nofollow"
									title="帮助中心">帮助中心</a>
							</div>
							<div class="header-item"><a @click="$router.push('/about')" class="" rel="nofollow"
									title="关于我们">关于我们</a>
							</div>
							<div class="header-item"><a @click="openKefu" class="" rel="nofollow" title="联系客服">联系客服</a>
							</div>
						</div>
					</div>

				</el-row>
			</div>
		</div>
		<el-container v-if="!isMobile">





			<div class="inter">

				<el-row>

					<div class="header header1">
						<div class="flex_box">
							<div class="login">
								<a href=".">
									<div class="img1">
										<img src="./assets/pic/lianminglogo.png" class="pc-header-logo" />
									</div>
								</a>
							</div>
							<div class="nav_top">
								<ul class="nav_list">
									<li v-for="(item, index) in navlist">
										<router-link :to="{ path: item.path }">
											<p>{{ item.name }}</p>
										</router-link>


									</li>

									<div class="lianxi_kefu" @click="openKefu">
										联系客服
									</div>

								</ul>
							</div>

						</div>
					</div>

				</el-row>

			</div>
		</el-container>


		<!-- <router-view :key="this.$route.path"></router-view> -->
		<router-view ref="view" class="bg home_content" />



		<div class="footer">
			<div class="inter">

				<div class="div1">
					<div class="fl" @click="openKefu">
						<div class="wp1">官方在线客服</div>
						<div class="p2">在线客服</div>
						<div class="p3">周一至周日8:00-24:00</div>
					</div>
					<div class="con">
						<div class="wp1">快速链接</div>
						<div class="footer_link">
							<router-link :to="{ path: '/' }">
								<p>网站首页</p>
							</router-link>

							<router-link :to="{ path: '/about' }">
								<p>关于我们</p>
							</router-link>
							<router-link :to="{ path: '/business' }">
								<p>帮助中心</p>
							</router-link>

						</div>
					</div>
					<!-- <div class="fr">
						<div class="wp1" @click="openKefu">官方在线客服</div>
						<div class="code_img">
							<div class="image">

							</div>
						</div>
					</div> -->
				</div>
				<div class="div2">
					2026 KK账号网网.All rights reserved.
				</div>
			</div>
		</div>



		<el-backtop :visibility-height="0" :right="10" :bottom="80">

		</el-backtop>
		<sell ref="sell" />
		<login ref="login" />


		<el-dialog ref="kefu" :visible.sync="visible_kefu" :center="true" title="联系客服" width="600px" destroy-on-close
			@closed="visible_kefu = false">
			<div class="compensationModel_box">
				<div v-html="config.kefu">

				</div>
			</div>
		</el-dialog>

	</div>
</template>
<script>
import sell from '@/components/dialogs/sell'
import login from '@/components/dialogs/login'
export default {
	components: {
		sell,
		login
	},
	data() {
		return {

			sContent: "This is hello components",

			options: [],
			options2: [{
				value: '0',
				label: '暂无数据',
				disabled: true,
			}],
			options3: [{
				value: '0',
				label: '暂无数据',
				disabled: true,
			}],
			value: "",
			value2: '',
			value3: '',
			key: '',
			site: [],
			navlist: [{
				path: '/',
				name: '资源号出租'
			},
			{
				path: '/sell',
				name: '发布账号'
			},

			{
				path: '/mygoods',
				name: '我的商品'
			},
			{
				path: '/order',
				name: '订单管理'
			},
			],




			topheader: 0,
			winWidth: 1920,
			winHeight: 0,
			hot_index: 0,
			api_kefu: {},
			visible_kefu: false,
			wap_show: false


		}
	},
	computed: {


		login() {
			return this.$store.getters.login
		},
		open_login() {
			return this.$store.getters.open_login
		},

		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		config() {
			return this.$store.getters.config
		},
		userinfo() {
			return this.$store.getters.userinfo
		}
	},
	watch: {
		open_login(v) {
			if (v) {
				this.$refs['login'].visible = true
			}
		},
		winWidth: {
			handler(v) {
				this.$store.commit('SET_IS_MOBILE', v <= 750 ? true : false)
				var route = this.$route
				if (v <= 760) {
					this.$store.commit('SET_IS_MOBILE', true)
					if (route.name == 'goodsdetail') {
						location.href = this.wap_url + "/#/pages/index/detail?id=" + route.query.id
					} else if (route.name == 'goodsdetail2') {
						var str = route.params.id;
						var newStr = str.replace(/\.html$/, '');
						location.href = this.wap_url + "/#/pages/index/detail?id=" + newStr
					} else {
						location.href = this.wap_url
					}
				} else {
					this.$store.commit('SET_IS_MOBILE', false)
				}
			},
			immediate: true,
		},

	},
	activated() {

	},
	created: function () {


		this.$store.dispatch('getgameGameList')

		this.$store.dispatch('getCenterConfig')

		this.token()
		var that = this;
		setTimeout(function () {

			if (that.$route.query.topheader != undefined && that.$route.query.topheader != "") {
				that.$data.topheader = that.$route.query.topheader;
			}



			setTimeout(function () {
				if (that.$route.query.keyword != undefined && that.$route.query.keyword != "") {
					that.$data.key = that.$route.query.keyword;
				}
			}, 100);

		}, 500);

		this.getWinWidth()
		this.getWinHeight()

		window.onresize = () => {
			return (() => {
				this.getWinWidth()
				this.getWinHeight()

			})()
		}
	},
	methods: {
		logout() {
			localStorage.removeItem('usertoken')
			sessionStorage.removeItem('usertoken')
			this.$store.commit('SET_userinfo', {})
			this.$store.commit('SET_login', false)
			this.$router.push("/")
			location.reload()
		},
		openKefu() {
			// this.visible_kefu = true
				api_kefu.push('cmd', 'kfclient');
				api_kefu.push('type', 'new');
				api_kefu.query();
		},
		openLogin(index) {
			this.$refs['login'].active = index
			this.$refs['login'].visible = true
		},
		fanhui() {
			// this.$scrollTo('.element-to-scroll-to', 500, { offset: -50 });
		},
		openMai() {
			this.$refs['sell'].visible = true
		},
		getWinWidth() {
			window.width = document.body.clientWidth
			this.winWidth = window.width

		},
		getWinHeight() {
			window.height = document.body.clientHeight
			this.winHeight = window.height
		},
		getSite() {
			this.rq.requests.post("/api/Hall/getSite", {}).then(res => {
				this.$data.site = res.data;

			}).catch(error => {

			})
		},
		token() {
			var that = this
			this.rq.requests.post("api/game/hall/Token", {
				token: localStorage.getItem('usertoken')
			}).then(res => {

				localStorage.setItem('usertoken', res.data.userinfo.token)
				that.$store.commit('SET_userinfo', res.data.userinfo)
				that.$store.commit('SET_login', true)
			}).catch(error => {
				localStorage.removeItem('usertoken')
				sessionStorage.removeItem('usertoken')
			})
		},

		gamechange(id) {

			// this.getDaqu(this.$data.value);
			this.$data.value2 = '';
			this.$data.value3 = '';
		},
		daquchange() {

			this.getFuwuqi(this.$data.value2);
			this.$data.value3 = '';
		},

		serch() {



			if (this.$data.value != "") {
				this.$router.push({
					path: '/game?gtype=' + this.$data.value + "&keyword=" + this.$data.key
				})
			}

		}

	}
}
</script>